import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DynamicRule, RuleEntity } from '@pdqdev/pdq-shared/dist/entities/Rules';
import { DeliveryCountdownTimerFormGroup } from '../../models';

@Component({
  selector: 'delivery-countdown-timer-form-display-conditions',
  templateUrl: './delivery-countdown-timer-form-display-conditions.component.html',
  styleUrl: './delivery-countdown-timer-form-display-conditions.component.scss',
  standalone: false,
})
export class DeliveryCountdownTimerFormDisplayConditionsComponent {
  @Input() formGroup: FormGroup<DeliveryCountdownTimerFormGroup>;
  @Input() displayRules: DynamicRule[];
  @Input() displayRulesEntities: RuleEntity[];
  @Input() shopCurrencySymbol: string;
}
